var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mouse_sensor"},[_c('dpi-setting'),_c('report-rate'),_c('sensor-setting',{directives:[{name:"show",rawName:"v-show",value:(_vm.sensorShow),expression:"sensorShow"}]}),_c('dpi-effect',{directives:[{name:"show",rawName:"v-show",value:(_vm.effectShow),expression:"effectShow"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }